import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Components
import CategoryLink from './CategoryLink';

const Sidebar = ({ categories, widgets }) => {
	return (
		<nav className="sidebar">
			<h2></h2> {/* What to call this section?? */}
			<div className="scroll">
				{/* HTML Links */}
				<div className="nav-links">
					<div className="nav-link"><NavLink to={'/widgets/intro'}>Introduction</NavLink></div>
					<div className="nav-link"><NavLink to={'/widgets/how'}>How Widgets Work</NavLink></div>
					<div className="nav-link"><NavLink to={'/widgets/customize'}>Customization</NavLink></div>
					<div className="nav-link"><NavLink to={'/widgets/style'}>Styling</NavLink></div>
					<h2>Widget Reference</h2>
					{Object
						.keys(categories)
						.sort()
						.map(category => <CategoryLink
							key={category}
							index={category}
							category={categories[category]}
							widgets={widgets}
						/>)
					}
				</div>
			</div>
		</nav>
	);
};

Sidebar.propTypes = {
	categories: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/widgets/Sidebar.js